<dx-popup
    [title]="titleTemplate ? '' : titleText"
    [showCloseButton]="true"
    [(visible)]="visible"
    [fullScreen]="!!(screen.xSmallScreenChanged | async)"
    [width]="width"
    [maxWidth]="maxWidth"
    [height]="height"
    [wrapperAttr]="getWrapperAttrs | apply: wrapperAttr"
    (onHidden)="close()"
    [maxHeight]="maxHeight ?? height"
>
    @if (titleTemplate) {
        <dxi-popup-toolbar-item toolbar="top" location="before">
            <div class="dx-item dx-toolbar-item dx-toolbar-label">
                <div class="dx-item-content dx-toolbar-item-content">
                    <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
                </div>
            </div>
        </dxi-popup-toolbar-item>
    }
    @if (footerButtons().length < 1) {
        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <dx-button [text]="'cancel' | transloco" stylingMode="contained" type="normal" (onClick)="close()"></dx-button>
        </dxi-popup-toolbar-item>
        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <dx-button
                [text]="'save' | transloco"
                stylingMode="contained"
                type="default"
                [disabled]="isSaveDisabled"
                (onClick)="onSaveClick()"
            ></dx-button>
        </dxi-popup-toolbar-item>
    } @else {
        @for (button of footerButtons(); track $index) {
            <dxi-popup-toolbar-item toolbar="bottom" [location]="button.section">
                <dx-button
                    [text]="button.text | transloco"
                    [stylingMode]="button.stylingMode ?? 'contained'"
                    [type]="button.type ?? 'normal'"
                    [disabled]="button.disabled ?? false"
                    [elementAttr]="{ class: button.cssClass }"
                    [icon]="button.icon"
                    (onClick)="onFooterButtonClick(button.action)"
                ></dx-button>
            </dxi-popup-toolbar-item>
        }
    }
    <dx-validation-group #validationGroup>
        <ng-content></ng-content>
    </dx-validation-group>
</dx-popup>
